/**
 * View-mode toggle (cards vs table) + Cart button with item badge.
 *
 * Extracted from ProductsPage.js. Pure JSX with
 * props for state + callbacks — no internal state.
 */
import React from 'react';
import { Button } from '../../../components/ui/button';
import { Package, Layers, ShoppingCart } from 'lucide-react';


export function ViewToggleAndCart({ viewMode, onSetViewMode, cartCount, onGoToCart }) {
  return (
    <>
      <div className="flex rounded-full border border-heda-line bg-white p-0.5">
        <Button
          variant={viewMode === 'cards' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSetViewMode('cards')}
          className={`rounded-full h-8 w-8 p-0 border-0 shadow-none ${viewMode === 'cards' ? 'bg-heda-ink text-white hover:bg-black' : 'bg-transparent text-heda-mute hover:bg-heda-cream hover:text-heda-ink'}`}
          data-testid="view-mode-cards"
        >
          <Package className="w-4 h-4" />
        </Button>
        <Button
          variant={viewMode === 'table' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSetViewMode('table')}
          className={`rounded-full h-8 w-8 p-0 border-0 shadow-none ${viewMode === 'table' ? 'bg-heda-ink text-white hover:bg-black' : 'bg-transparent text-heda-mute hover:bg-heda-cream hover:text-heda-ink'}`}
          data-testid="view-mode-table"
        >
          <Layers className="w-4 h-4" />
        </Button>
      </div>
      <Button
        onClick={onGoToCart}
        variant="outline"
        size="sm"
        className="rounded-xl bg-white border-heda-line text-heda-ink hover:bg-white hover:border-heda-gold hover:text-heda-gold relative h-9 text-xs sm:text-sm"
        data-testid="go-to-cart-from-products"
      >
        <ShoppingCart className="w-4 h-4 sm:mr-1" />
        <span className="hidden sm:inline">Cart</span>
        {cartCount > 0 && (
          <span
            className="absolute -top-1.5 -right-1.5 bg-heda-gold text-white text-[10px] w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center font-bold"
            data-testid="products-cart-badge"
          >
            {cartCount}
          </span>
        )}
      </Button>
    </>
  );
}
